import { useDeleteMutation } from "../../hooks/general/useDeleteMutation";
import { paths } from "../../navigation/paths";
import { appStrings } from "../../resources/strings/app";
import { conversationStrings as strings } from "../../resources/strings/conversations";
import { api } from "../../services/conversations.service";
import type { ConversationData } from "../../types/documents/Conversation";
import { BreadcrumbHeader } from "../general/BreadcrumbHeader";
import { DeleteEntityButton } from "../general/DeleteEntityButton";
import { Loader } from "../general/Loader";
import { SaveEntityButtons } from "../general/SaveEntityButtons";
import type { CustomProps } from "../general/types/Modify";
import { crumbs } from "./crumbs";

interface Props extends CustomProps<ConversationData> {}
type Component = (props: Props) => JSX.Element;

export const ConversationBreadcrumbHeader: Component = (props) => {
  const { data, mode, permissions } = props;
  const { clientId, caseId, conversationId } = data;

  const { deleteInProgress, deleteFn } = useDeleteMutation(
    api.delete,
    caseId,
    conversationId,
    paths.cases.view(clientId, caseId)
  );

  return (
    <BreadcrumbHeader
      crumbs={crumbs(mode, clientId, caseId)}
      children={
        <Loader active={deleteInProgress} inline>
          <>
            {mode !== "create" && (
              <DeleteEntityButton
                permissions={permissions}
                config={{
                  label: strings.labels.delete,
                  heading: strings.header.deleteConversation,
                  message: strings.labels.confirmDelete,
                  entity: appStrings.entities.conversations,
                }}
                handleDelete={deleteFn}
              />
            )}
            <SaveEntityButtons
              {...props}
              config={{
                entity: appStrings.entities.conversations,
                editLabel: strings.labels.edit,
                saveLabel: strings.labels.save,
                resetLabel: strings.labels.reset,
              }}
            />
          </>
        </Loader>
      }
    />
  );
};
